import MarkerPng from "./assets/map-marker.png";
import Houses from "./assets/houses.png";
const CustomIcons = [
  {
    src: MarkerPng,
    name: "my-marker",
  },
  {
    src: Houses,
    name: "houses",
  },
];

export default CustomIcons;
